import { CaretDownIcon } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { DropdownProps } from 'semantic-ui-react';

import { useUserflow } from '../../integrations';

import { changeLanguage, DEFAULT_LANGUAGE } from '../../i18n';
import LanguagePicker, { LANGUAGE_OPTIONS } from './LanguagePicker';

const ChangeLanguage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || DEFAULT_LANGUAGE;
  const { userflowInitialize } = useUserflow();

  const onChange = async (_event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    changeLanguage(data.value as string);
    await userflowInitialize();
  };

  const currentText =
    LANGUAGE_OPTIONS.find((option) => option.value === currentLanguage)?.text ?? LANGUAGE_OPTIONS[0].text;

  // Reuses the shared LanguagePicker (options + Semantic Dropdown), adding the
  // nav-switcher behavior and the shared design-system caret. Matches the
  // user-profile dropdown: caret sits right next to the trigger text.
  return (
    <LanguagePicker
      trigger={<span>{currentText}</span>}
      value={currentLanguage}
      onChange={onChange}
      icon={<CaretDownIcon className="ml-1 inline size-3.5 align-middle" />}
      aria-label={t('Language')}
      data-testid="language-picker-link"
    />
  );
};

export default ChangeLanguage;
